import "./Layout.scss";

import React, { FC, useContext, useEffect, useState } from "react";
import Header from "./Header";
import ContactMarquee from "./ContactMarquee";
import NavContext from "./Nav/NavProvider";
import { useWindowSize } from "../../hooks/useWindowSize";
import Cursor from "../Cursor";
import { Cookies } from './Cookies';

export interface LayoutProps {
  children: unknown;
  language?: string;
  alternativeSlug?: string;
  alternativeUrls?: string[];
  isHome?: boolean;
  alternativeText?: string;
  hideMenu?: boolean;
  isCookiesHidden?: boolean;
}

enum BodyClasses {
  IsTouchDevice = 'is-touch-device',
  IsMobileDevice = 'is-mobile-device'
}

const env = process.env.NODE_ENV;

const Layout: FC<LayoutProps> = ({ children, alternativeText, alternativeSlug, hideMenu, isCookiesHidden}) => {
  const { isTouchDevice, isMobile } = useContext(NavContext);
  const [isMobileActive, setIsMobileActive] = useState<boolean>(false);
  const windowWidth = useWindowSize();

  const setBodyClasses = () => {
    const bodyClasslist = document.body.classList;
    if (isTouchDevice()) {
      bodyClasslist.add(BodyClasses.IsTouchDevice);
    } else {
      bodyClasslist.remove(BodyClasses.IsTouchDevice);
    }

    if (isMobile()) {
      bodyClasslist.add(BodyClasses.IsMobileDevice);
    } else {
      bodyClasslist.remove(BodyClasses.IsMobileDevice);
    }
  };

  useEffect(setBodyClasses, [windowWidth]);

  useEffect(() => {
    setIsMobileActive(isMobile());
  }, [isMobile])

  return (
    <>
      {!isMobileActive && <Cursor /> }
      <div className="youplanet-web">
        {!hideMenu &&
          <>
          { env != 'development' ?
            <Cookies defaultHidden={isCookiesHidden} />
            : <></>
          }
          <Header alternativeSlug={alternativeSlug} alternativeText={alternativeText} />
          { !isMobileActive &&
            <div className='youplanet-web__contact'>
              <ContactMarquee alternativeSlug={alternativeSlug} alternativeText={alternativeText} />
            </div>
          }
          </>
        }
        <main className="youplanet-web__content">{children}</main>
      </div>
    </>
  );
};

export default Layout;
